@let isHomePage = pageIs().home;
@let isMenuPage = pageIs().menu;
@let isServicePage = pageIs().service;
@let isInvoicePage = pageIs().invoice;

<div
  [class.hide]="hideTabBar()"
  class="tab-bar"
>
  <div class="tabs" coreActivitySection="TabBar">
    <button
      class="tab"
      [class.underline]="isMenuPage"
      [routerLink]="isMenuPage ? '/main/home' : '/main/menu'"
      routerLinkActive="active"
      [coreUserActivityClickTracking]="isMenuPage ? 'MenuClose' : 'MenuOpen'"
    >
      <div class="icon menu-icon">
        <img class="active" src="/images/menu.svg" width="64" height="76" alt=""/>
      </div>
      <div class="label menu-text active">
        <span>{{ 'tabBar.menu' | translate }}</span>
      </div>
    </button>

    <button
      class="tab"
      [class.underline]="isServicePage"
      [routerLink]="isHomePage ? '/main/home/service' : '/main/home'"
      routerLinkActive="active"
      [coreUserActivityClickTracking]="isHomePage ? 'ServicePageOpen' : 'PageClose'"
    >
      @if (callWaiterMain()) {
        <app-call-waiter-indicator class="call-waiter" [active]="true"/>
      }

      <div class="logo">
        <img src="/images/logo.svg" width="76" height="76" alt=""/>
      </div>
      <div class="label" [class.active]="isHomePage">
        <span>{{ 'tabBar.serviceCentre' | translate }}</span>
      </div>
    </button>

    <button
      class="tab"
      [class.underline]="isInvoicePage"
      [routerLink]="isInvoicePage ? '/main/home' : '/main/invoice'"
      routerLinkActive="active"
      [coreUserActivityClickTracking]="isInvoicePage ? 'InvoicePageClose' : 'InvoicePageOpen'"
    >
      @if (callWaiterRequestBill()) {
        <app-call-waiter-indicator class="call-waiter" [active]="true"/>
      }

      <div class="icon">
        <svg width="64" height="76" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M63.454 44.394H48.972l.191-37.255c.008-1.615.443-3.246 1.562-4.412 3.496-3.642 7.724-3.592 11.357-.114 1.274 1.219 1.77 3 1.752 4.762l-.38 37.019Z"
            fill="#FFEED4"/>
          <path fill-rule="evenodd" clip-rule="evenodd"
                d="M.834 8.165V76l6.12-6.113L13.071 76l5.712-5.705L24.494 76l5.712-5.705L35.917 76l5.711-5.705L47.34 76V7.131c.086-2.963.323-4.598 3.467-7.131H9.264C8.012 0 6.763.264 5.678.889 3.329 2.24 1.969 3.639 1.126 6.14.907 6.79.834 7.48.834 8.165ZM8.993 16.3a1.223 1.223 0 1 0 0 2.445h31.004a1.223 1.223 0 1 0 0-2.445H8.993ZM7.769 26.488c0-.675.548-1.223 1.224-1.223h31.004a1.223 1.223 0 1 1 0 2.445H8.993a1.223 1.223 0 0 1-1.224-1.222Zm1.224 7.743a1.223 1.223 0 1 0 0 2.445H19.19a1.223 1.223 0 1 0 0-2.445H8.993Zm-1.224 9.372c0-.675.548-1.222 1.224-1.222H19.19a1.223 1.223 0 1 1 0 2.445H8.993a1.223 1.223 0 0 1-1.224-1.223Zm1.224 6.928a1.223 1.223 0 1 0 0 2.445H19.19a1.223 1.223 0 1 0 0-2.445H8.993Zm-1.224 9.373c0-.676.548-1.223 1.224-1.223H19.19a1.223 1.223 0 1 1 0 2.445H8.993a1.223 1.223 0 0 1-1.224-1.222Zm25.915 1.221h.531c0-.21 0-.416.002-.616.001-.584.003-1.136-.01-1.704 0-.341.097-.472.389-.532a6.632 6.632 0 0 0 2.903-1.395c2.469-2.038 3.07-6.968.044-9.437a14.055 14.055 0 0 0-2.01-1.356 29.784 29.784 0 0 0-1.59-.806c-.481-.231-.962-.463-1.436-.72-.557-.3-1.106-.652-1.575-1.094-.796-.753-.761-2.169.044-2.901.93-.844 2-.854 3.062-.422.992.402 1.39 1.335 1.425 2.48.018.361.133.462.425.462 1.035-.01 2.062-.02 3.097 0 .346 0 .452-.121.452-.522.017-2.982-1.425-5.231-3.947-6.114-.12-.043-.256-.074-.392-.104-.311-.07-.623-.141-.759-.358-.144-.228-.115-.604-.085-.975a5.73 5.73 0 0 0 .023-.44c0-.603 0-.89-.144-1.029-.132-.126-.386-.126-.873-.126h-1.78c0 .288-.001.565-.003.836-.004.521-.008 1.017.004 1.513.009.301-.071.442-.354.492-1.08.19-2.071.642-2.947 1.395-2.345 1.998-3.01 6.506-.098 9.005.381.322.762.643 1.177.884.577.33 1.162.639 1.747.947a70.761 70.761 0 0 1 1.554.84c.673.381 1.352.766 1.992 1.215.654.452.955 1.164.814 2.058-.142.883-.575 1.496-1.319 1.787-.823.331-1.655.331-2.487.07-1.185-.371-1.84-1.355-1.876-2.76 0-.117-.007-.23-.015-.346l-.011-.197h-3.894c-.301 3.062.902 5.422 3.354 6.576.54.251 1.115.412 1.69.562.345.093.496.108.562.19.07.088.044.25.049.664.003.2.003.4.002.602 0 .336-.001.672.015 1.004.01.13.16.351.248.351.656.025 1.313.023 2 .021Z"
                fill="#FFEED4"/>
        </svg>
      </div>
      <div class="label" [class.active]="isInvoicePage">
        <span>{{ 'tabBar.payBill' | translate }}</span>
      </div>
    </button>
  </div>
</div>

@if (hideTabBar()) {
  <core-interacts-present/>
}
